
import Button from '../base/Button';

export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contato');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section 
      className="relative min-h-screen flex items-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://readdy.ai/api/search-image?query=Professional%20business%20investigation%20office%20with%20modern%20technology%2C%20security%20documents%2C%20and%20corporate%20environment.%20Clean%2C%20sophisticated%20workspace%20with%20investigative%20tools%2C%20computers%2C%20and%20legal%20documents.%20Professional%20lighting%2C%20minimal%20background%2C%20corporate%20atmosphere%2C%20high-tech%20security%20equipment%2C%20business%20professional%20setting&width=1920&height=1080&seq=hero-investigation&orientation=landscape')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="max-w-3xl">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Proteja Sua Empresa com 
            <span className="text-teal-400"> Investigação Especializada</span>
          </h2>
          
          <p className="text-xl text-gray-200 mb-8 leading-relaxed">
            Resolvo fraudes internas, vazamentos de informação e questões patrimoniais com 
            investigações imparciais e documentação legal adequada. Expertise comprovada 
            para proteger seus interesses empresariais.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4">
            <Button onClick={scrollToContact} size="lg" className="text-lg">
              <i className="ri-phone-line mr-2"></i>
              Solicitar Consultoria Gratuita
            </Button>
            <Button 
              variant="outline" 
              size="lg" 
              className="text-white border-white hover:bg-white hover:text-gray-900"
              onClick={() => document.getElementById('servicos')?.scrollIntoView({ behavior: 'smooth' })}
            >
              Conhecer Serviços
            </Button>
          </div>
          
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 text-white">
            <div className="text-center md:text-left">
              <div className="text-3xl font-bold text-teal-400">15+</div>
              <div className="text-sm text-gray-300">Anos de Experiência</div>
            </div>
            <div className="text-center md:text-left">
              <div className="text-3xl font-bold text-teal-400">500+</div>
              <div className="text-sm text-gray-300">Casos Resolvidos</div>
            </div>
            <div className="text-center md:text-left">
              <div className="text-3xl font-bold text-teal-400">100%</div>
              <div className="text-sm text-gray-300">Confidencialidade</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
